import React, { useEffect, useMemo, useState } from "react";
import { RadarMic, VoiceRecorder } from "../../../components/globals/VoiceRecorder";
import { SelectComponent } from "../../../components/Select";
import Button from "../../../components/globals/button";
import shaia from "../../../assets/new_shaia.png";
import classNames from "classnames";
import { AudioFileState, FileCard, FileCardAws, FileSelector, sizeTombandgb } from "../../../components/globals/File";
import { updateData, useConditionedNavigator } from "../../../store/ConditionenNavigationProvider";
import Input from "../../../components/globals/input";
import { ProgressBar } from "../../../components/globals/ProgressBar";
import { key_hidden, useCreateTranscription, useDetailsAudio, useEditTranscript, useSelectFile, useSessionClass, useUploadFile } from "./hook";
import { DropdownOption, Modal, useModal } from "../../../components/form-elements/Modals";
import { AutoResizeTextarea } from "../../../components/TextArea";
import { useSelector } from "../../../components/form-elements/InputCheck";
import { deleteS3Object } from "../../../services/aws.service";
import ChatSkeleton from "../../../components/skeletons/ChatSkeleton";
import { useTranslator } from "../../../hooks/useTranslator";
import { clearXML, extractOptions } from "../../../services/chat.service";
import { exportToDocx, htmlToPdf } from "../../../utils/Utils";
import { useRemarkable } from "../../../hooks/useRemarkable";
import useSessionStore from "../../../store/useSessionStore";
import { useNavigate } from "react-router-dom";
import { useChat } from "../../../store/chatProvider";
import useGlobalStore from "../../../store/useGlobalStore";
import { getAllProfileClass2 } from "../../../services/profile-class.service";
import { useQueryAdapter } from "../../../hooks/useQueries";
import { useInputValidations } from "../../../hooks/useInput";
import Bubble from "../../../components/Bubble/Bubble";
import { MarkDownViwer } from "../../../components/markDownViwer";

export const GarbageSVG = () => {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.6668 24V50.6667H21.3335V24H42.6668ZM38.6668 8H25.3335L22.6668 10.6667H13.3335V16H50.6668V10.6667H41.3335L38.6668 8ZM48.0002 18.6667H16.0002V50.6667C16.0002 53.6 18.4002 56 21.3335 56H42.6668C45.6002 56 48.0002 53.6 48.0002 50.6667V18.6667Z" fill="#3D96C2" />
        </svg>
    );
}

export const CloudUploadImage = () => {
    return (
        <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.8 8.38671C24.8933 3.78671 20.8533 0.333374 16 0.333374C12.1467 0.333374 8.8 2.52004 7.13333 5.72004C3.12 6.14671 0 9.54671 0 13.6667C0 18.08 3.58667 21.6667 8 21.6667H25.3333C29.0133 21.6667 32 18.68 32 15C32 11.48 29.2667 8.62671 25.8 8.38671ZM25.3333 19H8C5.05333 19 2.66667 16.6134 2.66667 13.6667C2.66667 10.9334 4.70667 8.65337 7.41333 8.37337L8.84 8.22671L9.50667 6.96004C10.7733 4.52004 13.2533 3.00004 16 3.00004C19.4933 3.00004 22.5067 5.48004 23.1867 8.90671L23.5867 10.9067L25.6267 11.0534C27.7067 11.1867 29.3333 12.9334 29.3333 15C29.3333 17.2 27.5333 19 25.3333 19ZM10.6667 12.3334H14.0667V16.3334H17.9333V12.3334H21.3333L16 7.00004L10.6667 12.3334Z" fill="#3D96C2" />
        </svg>
    );
}

export const EqSvg = () => {
    return (
        <svg width="48" height="54" viewBox="0 0 48 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6667 42.9999H16V10.9999H10.6667V42.9999ZM21.3333 53.6666H26.6667V0.333252H21.3333V53.6666ZM0 32.3333H5.33333V21.6666H0V32.3333ZM32 42.9999H37.3333V10.9999H32V42.9999ZM42.6667 21.6666V32.3333H48V21.6666H42.6667Z" fill="#3D96C2" />
        </svg>
    );
}


export const Text2 = ({ text, translator, className }) => {
    const { t } = useTranslator();
    return (
        <label className={classNames("text-white text-2xl font-bold text-center", className)}>{t(text, translator)}</label>
    );
}

export const Text3 = ({ text, translator, className }) => {
    const { t } = useTranslator();
    return (
        <label className={classNames("text-white text-xl font-bold text-center", className)}>{t(text, translator)}</label>
    );
}

export const Text1 = ({ text, translator, className }) => {
    const { t, traslate } = useTranslator();
    return (
        typeof text === "string" ?
            <label className={classNames("text-white text-4 text-center", className)}>{t(text, translator)}</label> :
            <label className={classNames("text-white text-4 text-center", className)}>{traslate(text)}</label>
    );
}

export const TextListItem = ({ text, translator, number, texttitle }) => {
    const { t } = useTranslator();
    return (
        <div className="flex w-full text-white text-4 justify-start">
            {number ? <label className="font-bold pr-2">{number}</label> : null}
            <p>
                <span className="font-bold pr-2">{t(texttitle, translator)}</span>
                {t(text, translator)}
            </p>
        </div>
    );
}

export const SelectClassProfile = ({ onSelect }) => {
    const { user } = useSessionStore();
    const navigate = useNavigate();
    const { t } = useTranslator();
    const { data, isLoading, setData } = useQueryAdapter({ fnquery: getAllProfileClass2, data: null });
    const { bind, value } = useSelector();
    useEffect(() => {
        if (user?.email) setData(user);
    }, [user, setData])
    const options = useMemo(() => {
        return data?.map(i => ({ label: i?.class_name, value: i?.id, data: i }));
    }, [data]);
    const handelOnClick = () => {
        if (!value?.data) return;
        onSelect?.(value.data);
    }
    const handelOnClickCreate = () => {
        navigate("/my-classes");
    }
    return (
        <div className="flex flex-col items-center w-full mt-4 md:mt-8 max-w-[500px]">
            <div className="mb-8">
                <img src={shaia} alt="img" className="w-[80px] h-[80px] rounded-full bg-[black]/10" />
            </div>
            <div className="mb-8">
                <Text1 text="enad_feed_back_choice_group" />
            </div>
            <div className="mb-8">
                {
                    isLoading ? <Text2 text="..." /> :
                        <SelectComponent placeholder={t("select")} {...bind} className="w-[250px]" options={options} />
                }
            </div>
            <div className="flex items-center gap-4">
                <Button onClick={handelOnClickCreate} variant="tertiary" type="button" label="create" />
                <Button onClick={handelOnClick} type="button" label="continue" />
            </div>
        </div>
    );
}

export const NoPlannedSessions = () => {
    const navigate = useNavigate();
    const { currentItem } = useConditionedNavigator();
    const { idClassProfile } = currentItem ?? {};
    const { setSuperPowerconection } = useGlobalStore();
    const handleClick = () => {
        navigate("/design-enad-class");
        setSuperPowerconection({ idClassProfile,target:'enad_class' });
    }
    return (
        <div className="flex flex-col items-center gap-4 w-full mt-4 md:mt-8 gap-8 max-w-[700px]">
            <CardInfo1 title="enad_feed_back_no_plans" text="enad_feed_back_create_plan_prompt" />
            <Button onClick={handleClick} type="button" label="enad_feed_back_create_plan_button" />
        </div>
    );
}


export const SelectPlan = () => {
    const { t } = useTranslator();
    const { currentItem } = useConditionedNavigator();
    const { idClassProfile } = currentItem ?? {};
    const { dispatch } = useConditionedNavigator();
    const { isLoading, options, setData } = useSessionClass();
    const { bind, value } = useSelector();
    useEffect(() => {
        if (idClassProfile) {
            setData({ filter: { classProfileId: +idClassProfile, useCase: "enad_class3" } });
        }
    }, [idClassProfile, setData]);
    const handelOnClick = () => {
        updateData(dispatch, { plan: value });
    }
    if (!options?.length) return <NoPlannedSessions />

    return (
        <div className="flex flex-col items-center w-full mt-4 md:mt-8 max-w-[500px]">
            <div className="w-fit mb-8">
                <RadarMic />
            </div>
            <div className="w-fit mb-2">
                <Text2 text="enad_feed_back_feedback_your_planned_sessions" />
            </div>
            <div className="w-fit mb-8">
                <Text1 text="enad_feed_back_which_planning_to_feedback_today" />
            </div>
            <div className="w-fit mb-8">
                {
                    isLoading ? <Text2 text="..." /> :
                        <SelectComponent {...bind} className="w-[250px]" options={options} placeholder={t("enad_feed_back_choose_planning")} />
                }
            </div>
            <Button onClick={handelOnClick} type="button" label="enad_feed_back_start_feedback" />
        </div>
    );
}

export const CardInfo1 = ({
    title = "enad_feed_back_dont_worry",
    text = "enad_feed_back_no_images_or_voices"
}) => {
    return (
        <div className="flex items-center gap-4 flex-col md:flex-row">
            <img src={shaia} alt="img" className="w-[80px] h-[80px] rounded-full bg-[black]/10" />
            <div className="flex flex-col items-left gap-2 w-full">
                <Text3 text={title} className={"text-start"} />
                <Text1 text={text} className={"text-start"} />
            </div>
        </div>
    );
}

export const SelectMethod = ({ sizeinmb }) => {
    const { dispatch } = useConditionedNavigator();
    const handleOnClickUpload = () => updateData(dispatch, { method: "upload" });
    const handleOnClickRecording = () => updateData(dispatch, { method: "record" });
    return (
        <div className="flex flex-col items-center w-full mt-4 md:mt-8 max-w-[600px]">
            <div className="w-fit mb-8">
                <RadarMic />
            </div>
            <div className="w-fit mb-2">
                <Text2 text="enad_feed_back_how_to_start_feedback" />
            </div>
            <div className="w-fit mb-8">
                <Text1 text="enad_feed_back_upload_audio_file" translator={{ size: `${sizeinmb}MB` }} />
            </div>
            <div className="w-fit mb-12">
                <div className="flex items-center gap-4 flex-col md:flex-row">
                    <Button onClick={handleOnClickUpload} className={"min-w-[150px]"} type="button" variant="tertiary" label="enad_feed_back_upload_recording" />
                    <Button onClick={handleOnClickRecording} className={"min-w-[150px]"} type="button" variant="primary" label="enad_feed_back_start_recording" />
                </div>
            </div>
            <CardInfo1 />
        </div>
    );
}

export const LinearDiv = ({ children }) => {
    return (
        <div className="w-fit h-fit bg-[white]/0 border-2 border-dashed border-LightBlue-700 p-4 rounded-4">
            {children}
        </div>
    );
}

export const SelectFilePage = ({ sizeinmb }) => {
    const { bind, dispatch } = useSelectFile({ sizeinmb });
    const handleOnClickCancel = () => updateData(dispatch, { method: null });
    return (
        <div className="flex flex-col items-center w-full mt-4 md:mt-8 max-w-[500px]">
            <div className="w-fit mb-8">
                <LinearDiv >
                    <div className="flex flex-col items-center gap-4">
                        <CloudUploadImage />
                        <Text1 text="enad_feed_back_choose_file_to_upload" className={"!text-LightBlue-700"} />
                        <Text1 text="enad_feed_back_allowed_formats" translator={{ size: `${sizeinmb}MB` }} />
                    </div>
                </LinearDiv>
            </div>
            <div className="flex items-center gap-4 flex-col md:flex-row w-fit mb-12 ">
                <Button onClick={handleOnClickCancel} className={"min-w-[150px]"} type="button" variant="tertiary" label="enad_feed_back_cancel" />
                <FileSelector {...bind} Button={(props) =>
                    <Button {...props} className={"min-w-[150px]"} type="button" variant="primary" label="enad_feed_back_select_file" />
                } />
            </div>
            <CardInfo1 />
        </div>
    );
}

export const ModalSuggestions = ({ onAccept }) => {
    const { bind, closeModal } = useModal({ isOpen: true });
    const { dispatch } = useConditionedNavigator();
    const handleOnClickCancel = () => updateData(dispatch, { method: null });
    const handleOnClickContinue = () => {
        onAccept?.();
        closeModal();
    }
    return (
        <>
            <Modal {...bind} className="w-full md:w-[560px]">
                <div className="flex flex-col items-center gap-6 p-2 md:p-6">
                    <div className="flex items-center w-full justify-center">
                        <EqSvg />
                    </div>
                    <div className="flex flex-col items-center gap-4">
                        <Text2 text="enad_feed_back_before_starting_to_record" />
                        <div className="flex w-full flex-col">
                            <TextListItem number="1." texttitle="enad_feed_back_allow_microphone_access" text="enad_feed_back_allow_microphone_access_value" />
                            <TextListItem number="2." texttitle="enad_feed_back_device_location" text="enad_feed_back_device_location_value" />
                            <TextListItem number="3." texttitle="enad_feed_back_finish_recording" text="enad_feed_back_finish_recording_value" />
                            <TextListItem number="4." texttitle="enad_feed_back_review_transcription_modal" text="enad_feed_back_review_transcription_value" />
                            <TextListItem texttitle="enad_feed_back_note" text="enad_feed_back_note_value" />
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <Button onClick={handleOnClickCancel} className={"min-w-[100px]"} type="button" variant="tertiary" label="enad_feed_back_cancel" />
                        <Button onClick={handleOnClickContinue} className={"min-w-[110px]"} type="button" variant="primary" label="continue" />
                    </div>
                </div>
            </Modal>
        </>
    );
}

export const AudioControls = ({ getAudioFile, isRecording, startRecording, stopRecording, resetRecording, audioUrl, onClickFinish, onclickCancel }) => {
    const handleOnClickDelete = ({ closeModal }) => {
        resetRecording();
        closeModal();
    }
    return (
        <div className="flex items-center gap-4">
            <ModalSuggestions onAccept={startRecording} />
            {
                !audioUrl ? <Button onClick={onclickCancel} disabled={isRecording} className={"min-w-[100px]"} type="button" variant="tertiary" label="enad_feed_back_cancel" /> : null
            }
            {
                audioUrl ?
                    <ModalCancelAudio
                        labelButton="enad_feed_back_yes_restart"
                        labelMessage="enad_feed_back_reminder"
                        labelTitle="enad_feed_back_restart_prompt"
                        onClickDelete={handleOnClickDelete}
                        ButtonOpen={(props) => <Button {...props} className={"min-w-[100px]"} type="button" variant="tertiary" label="enad_feed_back_restart" />}
                    />
                    : null
            }
            {
                audioUrl ? <Button onClick={onClickFinish({ getAudioFile })} className={"min-w-[100px]"} type="button" variant="primary" label="enad_feed_back_finish" /> : null
            }
            {
                audioUrl ? null : (isRecording ? <Button onClick={stopRecording} className={"min-w-[100px]"} type="button" variant="primary" label="enad_feed_back_stop" /> :
                    <Button onClick={startRecording} className={"min-w-[100px]"} type="button" variant="primary" label="enad_feed_back_start" />)
            }
        </div>
    );
}

export const RecordPage = ({ sizeinmb }) => {
    const { dispatch } = useConditionedNavigator();
    const { bind } = useSelectFile({ sizeinmb });
    const handleOnclickCancel = () => updateData(dispatch, { method: null });
    const handleOnclickFinish = ({ getAudioFile }) => () => {
        bind.handleFileChange({ target: { files: [getAudioFile()] } });
    };

    return (
        <div className="flex items-center gap-12 flex-col mt-4 md:mt-8 max-w-[500px]">
            <VoiceRecorder
                ButtonPlay={(props) => <AudioControls {...props} onClickFinish={handleOnclickFinish} onclickCancel={handleOnclickCancel} />}
            />
            <CardInfo1 />
        </div>
    )
}

export const UploadFile = () => {
    const { currentData, handleOnClick, bind, dispatch } = useUploadFile();
    const { onKeyDownRegexp } = useInputValidations();
    const handleOnClickCancel = () => updateData(dispatch, { file: null });
    const handleOnRemove = () => updateData(dispatch, { file: null });

    return (
        <div className="flex items-center flex-col mt-4 md:mt-8 max-w-[500px]">
            <LinearDiv >
                <div className="flex flex-col items-center gap-4 max-w-[500px]">
                    <FileCard onRemove={handleOnRemove} file={currentData?.file} />
                    <Input
                        {...bind}
                        onKeyDown={onKeyDownRegexp(/^[a-zA-Z0-9\s\-:]+$/)}
                        placeholder='enad_feed_back_example_group_name'
                        label='enad_feed_back_name'
                        description='enad_feed_back_assign_name_to_recording'
                        type='text'
                        isForm={false}
                    />
                </div>
            </LinearDiv>
            <div className="flex gap-4 mb-12 mt-8">
                <Button className={"min-w-[150px]"} onClick={handleOnClickCancel} type="button" variant="tertiary" label="enad_feed_back_cancel" />
                <Button className={"min-w-[150px]"} disabled={!bind?.value?.trim?.()} onClick={handleOnClick} type="button" variant="primary" label="enad_feed_back_upload_file" />
            </div>
            <CardInfo1 />
        </div>
    );
}

export const ErrorUploadPage = ({ sizeinmb }) => {
    const { currentItem } = useConditionedNavigator();
    const { bind, dispatch } = useSelectFile({ sizeinmb });
    const handleOnclickCancel = () => updateData(dispatch, { method: null });
    return (
        <div className="flex items-center gap-4 flex-col mt-4 md:mt-8 max-w-[500px]">
            <LinearDiv >
                <FileCard
                    file={currentItem?.file}
                    className={"bg-Red-450/50"}
                    classNameIcon={"bg-Red-450"}
                    Message={() => <Text1 {...currentItem?.messageError ?? { text: "Error" }} />}
                />
            </LinearDiv>
            <div className="flex gap-4">
                <Button onClick={handleOnclickCancel} className={"w-[200px]"} type="button" variant="tertiary" label="enad_feed_back_cancel" />
                <FileSelector {...bind} Button={(props) =>
                    <Button {...props} className={"w-[200px]"} type="button" variant="primary" label="enad_feed_back_search_new_file" />
                } />
            </div>
            <CardInfo1 />
        </div>
    );
}

export const UploadingPage = () => {
    const { currentItem } = useConditionedNavigator();
    return (
        <div className="flex items-center gap-4 flex-col mt-4 md:mt-8 max-w-[500px]">
            <CardInfo1 title="enad_feed_back_uploading_file" text="enad_feed_back_take_a_break" />
            <ProgressBar progress={currentItem?.progress} />
        </div>
    );
}

export const ModalCancelAudioWithOutButton = ({
    ButtonOpen,
    labelButton = "enad_feed_back_yes_delete_it",
    labelTitle = "enad_feed_back_cancel_audio",
    labelMessage = "enad_feed_back_we_dont_store_audio",
    onClickDelete,
    bind,
    closeModal,
    openModal
}) => {
    const handleOnClickDelete = () => {
        onClickDelete?.({ closeModal });
    }
    return (<>
        <ButtonOpen onClick={openModal} />
        <Modal {...bind} className="min-w-[500px]">
            <div className="flex flex-col items-center gap-4">
                <GarbageSVG />
                <Text2 text={labelTitle} />
                <Text1 text={labelMessage} className="text-center" />
                <div className="flex items-center gap-4">
                    <Button onClick={closeModal} className={"min-w-[100px]"} type="button" variant="tertiary" label="enad_feed_back_cancel" />
                    <Button onClick={handleOnClickDelete} className={"min-w-[130px]"} type="button" variant="primary" label={labelButton} />
                </div>
            </div>
        </Modal>
    </>
    );
}

export const ModalCancelAudio = ({
    ButtonOpen,
    labelButton,
    labelTitle,
    labelMessage,
    onClickDelete
}) => {
    const { bind, openModal, closeModal } = useModal();
    return <ModalCancelAudioWithOutButton {...{ ButtonOpen, labelButton, labelMessage, labelTitle, bind, openModal, closeModal, onClickDelete }} />
}

export const DetailsAudio = () => {
    const { createTranscription } = useCreateTranscription();
    const { onKeyDownRegexp } = useInputValidations();
    const { value, bind, duration, currentItem, dispatch } = useDetailsAudio();
    const { sizeinmb, sizeingb } = sizeTombandgb(+(value?.params?.Metadata?.['x-amz-meta-size'] ?? 0));
    const handleOnClickDelete = ({ closeModal }) => {
        const deleteAudio = async () => {
            await deleteS3Object({ params: { Key: currentItem?.key } });
            if (currentItem.__isedit) {
                const newList = currentItem.__listtrascrips.filter(i => i?.Key !== currentItem?.key);
                updateData(dispatch, { key: null, progress: 0, listtrascrips: newList, __listtrascrips: newList, __isedit: false });
            } else updateData(dispatch, { key: null, progress: 0 });
            closeModal();
        }
        deleteAudio();
    }
    return (
        <div className="flex flex-col gap-6 w-full p-6 rounded-2 bg-DarkBlue-700 ">
            <FileCardAws file={value} />
            <Input
                {...bind}
                onKeyDown={onKeyDownRegexp(/^[a-zA-Z0-9\s\-:]+$/)}
                placeholder='enad_feed_back_example_group_name'
                label='enad_feed_back_name'
                type='text'
                isForm={false}
            />
            <div className="flex gap-4">
                <Input
                    value={duration}
                    readOnly
                    label='enad_feed_back_duration'
                    type='text'
                    isForm={false}
                />
                <Input
                    value={`${sizeinmb ?? sizeingb} ${sizeingb ? "GB" : "MB"}`}
                    readOnly
                    label='enad_feed_back_file_size'
                    type='text'
                    isForm={false}
                />
            </div>
            <div className="flex gap-4 justify-end">
                <ModalCancelAudio
                    onClickDelete={handleOnClickDelete}
                    ButtonOpen={(props) => <Button {...props} className={"min-w-[130px]"} type="button" variant="tertiary" label="enad_feed_back_cancel" />}
                />
                <Button onClick={createTranscription} className={"min-w-[230px]"} type="button" variant="primary" label="enad_feed_back_generate_transcription" />
            </div>
        </div>
    );
}
export const DetailsAudioPage = () => {
    return (
        <div className="flex items-center gap-12 flex-col max-w-[500px] mt-4 md:mt-8 max-w-[500px]">
            <DetailsAudio />
            <CardInfo1 title="enad_feed_back_file_uploaded_successfully" text="enad_feed_back_file_uploaded_success_message" />
        </div>
    );
}

export const EditTranscriptionCard = ({ index, item, options, updateData }) => {
    const idButton = `resetButton${index}`;
    const { text, speaker } = item;
    const [_text, setText] = useState(text);
    const [focused, setFocused] = useState();
    const value = useMemo(() => ({ label: speaker, value: speaker }), [speaker]);

    const handleOnChangeSpeaker = (value) => {
        updateData(index, { ...item, speaker: value?.value });
    }
    const handleOnChangeText = (evt) => {
        setText(evt);
    }

    const handleOnBlur = (evt) => {
        if (evt?.relatedTarget?.id === idButton) {
            setText(text);
        } else if (_text !== text) {
            updateData(index, { ...item, text: _text });
        }
        setFocused(false);
    }

    const handleOnClickCancel = () => {
    }

    const handleOnFocus = () => {
        setFocused(true);
    }
    return (
        <div className="flex justify-center w-full py-2 flex-col md:flex-row">
            <div cla>
                <SelectComponent value={value} className="w-[250px]" options={options} onChange={handleOnChangeSpeaker} />
            </div>
            <div className="flex flex-col items-center gap-4 w-[350px] md:w-[700px] px-4">
                <AutoResizeTextarea
                    onBlur={handleOnBlur}
                    onFocus={handleOnFocus}
                    focused={focused}
                    className={classNames("w-full h-[100px] bg-DarkBlue-850/20 text-white p-6 ", { 'bg-white !text-DarkBlue-500': focused })}
                    value={_text}
                    Options={({ focused: _focused }) => (<div className={classNames("flex items-center justify-end gap-4 overflow-hidden transition-all duration-300", { 'h-0': !_focused, 'h-fit': _focused })}>
                        <Button id={idButton} className="!min-w-[110px]" onClick={handleOnClickCancel} type="button" variant="tertiary" label="enad_feed_back_restore" />
                    </div>)}
                    onChange={handleOnChangeText} />
            </div>
        </div>
    );
}

const options = [
    {
        value: "Docente",
        label: "Docente"
    }, {
        value: "Estudiantes",
        label: "Estudiantes"
    }
];
export const EditTranscription = () => {
    const { isLoading, data, updateData, goToFeedBack, user } = useEditTranscript();
    const handleOnClickNext = () => {
        goToFeedBack();
    }

    if (isLoading) return <ChatSkeleton />;

    return (
        <div className="flex items-center gap-4 py-4 flex-col bg-DarkBlue-700 w-full flex-1 max-h-screen overflow-y-auto absolute top-0 h-full">
            <div className="flex w-full px-4">
                <Text3 text="enad_feed_back_review_and_correct_speakers" />
            </div>
            <div className="flex flex-col flex-1 bg-DarkBlue-350 w-full overflow-hidden overflow-y-auto">
                {data?.utterances?.map((item, index) => <EditTranscriptionCard key={index} index={index} item={item} options={options} updateData={updateData} />)}
            </div>
            <div className="flex w-full px-4 justify-between flex-col md:flex-row">
                <div className="h-full w-fit flex items-center justify-center flex-col md:flex-row">
                    <img src={shaia} alt="img" className="w-9 h-9 rounded-full bg-[black]/10 mr-4" />
                    <Text3 className={"!font-normal text-5"} text="enad_feed_back_continue_after_review" translator={{ name: user?.first_name }} />
                </div>
                <Button onClick={handleOnClickNext} className="min-w-[247px]" type="button" variant="primary" label="enad_feed_back_go_to_feedback" />
            </div>
        </div>
    );
}

export const TranscriptionProcessing = () => {
    const { currentItem } = useConditionedNavigator();
    return (
        <div className="flex items-center gap-4 flex-col mt-4 md:mt-8 max-w-[500px]">
            <CardInfo1 title="enad_feed_back_processing_transcription" text="enad_feed_back_estimated_time" />
            <ProgressBar progress={currentItem.trancriptionprocesses.progress} Message={() => <>(<Text1 text={currentItem.trancriptionprocesses.message} />)</>} />
        </div>
    );
}

export const TranscriptionReady = () => {
    const { currentItem, dispatch } = useConditionedNavigator();
    const handleOnClick = () => updateData(dispatch, { keytranscriptionedit: currentItem?.keytranscription });
    return (
        <div className="flex items-center gap-4 flex-col mt-4 md:mt-8 max-w-[500px]">
            <CardInfo1 title="enad_feed_back_transcription_ready" text="enad_feed_back_review_transcription" />
            <Button onClick={handleOnClick} className="min-w-[200px]" type="button" variant="primary" label="enad_feed_back_view_and_correct_transcription" />
        </div>
    );
}

export const AudioIconSvg = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.9927 30.1261H15.5581C11.8728 30.1261 8.88533 27.1386 8.88533 23.4534V8.54686C8.88533 4.8616 11.8728 1.8741 15.5581 1.8741H21.2001L30.6655 11.3395V23.4534C30.6655 27.1386 27.678 30.1261 23.9927 30.1261Z" fill="#EEF1F7" stroke="#CBD0DC" stroke-width="2.6691" />
            <rect y="14.2031" width="21.5729" height="12.5842" rx="4.67093" fill="#D5B06B" />
        </svg>
    );
}

export const HambugerSvg = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 10.6668C17.4667 10.6668 18.6667 9.46683 18.6667 8.00016C18.6667 6.5335 17.4667 5.3335 16 5.3335C14.5333 5.3335 13.3333 6.5335 13.3333 8.00016C13.3333 9.46683 14.5333 10.6668 16 10.6668ZM16 13.3335C14.5333 13.3335 13.3333 14.5335 13.3333 16.0002C13.3333 17.4668 14.5333 18.6668 16 18.6668C17.4667 18.6668 18.6667 17.4668 18.6667 16.0002C18.6667 14.5335 17.4667 13.3335 16 13.3335ZM16 21.3335C14.5333 21.3335 13.3333 22.5335 13.3333 24.0002C13.3333 25.4668 14.5333 26.6668 16 26.6668C17.4667 26.6668 18.6667 25.4668 18.6667 24.0002C18.6667 22.5335 17.4667 21.3335 16 21.3335Z" fill="#3D96C2" />
        </svg>
    );
}

export const MenuAudioFileState = ({ onClickDelete, onClickSeeDetails, state }) => {
    const { bind } = useModal();
    const { t } = useTranslator();
    const { bind: bindModalDelete, openModal, closeModal } = useModal();
    return (<>
        <ModalCancelAudioWithOutButton bind={bindModalDelete} onClickDelete={onClickDelete} closeModal={closeModal} ButtonOpen={() => null} />
        <DropdownOption className={"!bg-DarkBlue-700 p-2"} {...bind} ButtonControl={({ onClick }) => <div className='w-fit h-fit' onClick={onClick}><HambugerSvg /></div>} >
            <div className='flex flex-col gap-4 text-LightBlue-500 text-3'>
                {state?.type === "in_process" ?
                    <div className="whitespace-nowrap">{t("enad_feed_back_state_in_process_transcription")}</div>
                    : <>
                        <div className='flex gap-1 whitespace-nowrap items-center cursor-pointer' onClick={onClickSeeDetails}>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 7.25586C15.79 7.25586 19.17 9.38586 20.82 12.7559C19.17 16.1259 15.79 18.2559 12 18.2559C8.21 18.2559 4.83 16.1259 3.18 12.7559C4.83 9.38586 8.21 7.25586 12 7.25586ZM12 5.25586C7 5.25586 2.73 8.36586 1 12.7559C2.73 17.1459 7 20.2559 12 20.2559C17 20.2559 21.27 17.1459 23 12.7559C21.27 8.36586 17 5.25586 12 5.25586ZM12 10.2559C13.38 10.2559 14.5 11.3759 14.5 12.7559C14.5 14.1359 13.38 15.2559 12 15.2559C10.62 15.2559 9.5 14.1359 9.5 12.7559C9.5 11.3759 10.62 10.2559 12 10.2559ZM12 8.25586C9.52 8.25586 7.5 10.2759 7.5 12.7559C7.5 15.2359 9.52 17.2559 12 17.2559C14.48 17.2559 16.5 15.2359 16.5 12.7559C16.5 10.2759 14.48 8.25586 12 8.25586Z" fill="#3D96C2" />
                            </svg>
                            {t("enad_feed_back_see_details")}
                        </div>
                        <div className='flex gap-1 whitespace-nowrap items-center cursor-pointer' onClick={openModal}>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 19.7559C6 20.8559 6.9 21.7559 8 21.7559H16C17.1 21.7559 18 20.8559 18 19.7559V7.75586H6V19.7559ZM8 9.75586H16V19.7559H8V9.75586ZM15.5 4.75586L14.5 3.75586H9.5L8.5 4.75586H5V6.75586H19V4.75586H15.5Z" fill="#3D96C2" />
                            </svg>
                            {t("enad_feed_back_delete")}
                        </div>
                    </>}
            </div>
        </DropdownOption>
    </>
    )
}

export const TrancriptsCard = ({ item }) => {
    const { dispatch, currentItem } = useConditionedNavigator();
    const handleOnClickDelete = ({ closeModal }) => {
        const deleteAudio = async () => {
            await deleteS3Object({ params: { Key: item.Key } });
            updateData(dispatch, { key: null, progress: 0 });
            showListTranscription({ currentItem, dispatch, deletedKey: item.Key });
            closeModal();
        }
        deleteAudio();
    }

    const handleOnClickSeeDetails = () => {
        if (item?.transcription_key) {
            updateData(dispatch, { key: item.Key, keytranscriptionedit: item?.transcription_key, listtrascrips: null, __isedit: true });
        } else {
            updateData(dispatch, { key: item.Key, progress: 0, __isedit: true });
        }
    }
    return (<AudioFileState data={item} MenuAudioFileState={({ state }) => {
        return <MenuAudioFileState state={state} data={item} onClickDelete={handleOnClickDelete} onClickSeeDetails={handleOnClickSeeDetails} />
    }} />);
}

export const showListTranscription = ({ currentItem, dispatch, deletedKey }) => {
    const { listtrascrips, __listtrascrips } = currentItem;
    if (deletedKey) {
        const newList = __listtrascrips.filter(i => i?.Key !== deletedKey);
        updateData(dispatch, { listtrascrips: newList, __listtrascrips: newList, __isedit: false });
    } else if (listtrascrips?.length) updateData(dispatch, { listtrascrips: null });
    else {
        updateData(dispatch, { listtrascrips: __listtrascrips });
    }
}

export const ListTranscription = ({ data }) => {
    const { dispatch, currentItem } = useConditionedNavigator();
    const handleOnClick = () => showListTranscription({ currentItem, dispatch });
    return (
        <div className="flex flex-col w-full p-4 h-full">
            <div className="flex justify-between items-center my-4 flex-col md:flex-row">
                <Text3 text="enad_feed_trancriptions_state_label" className={"!text-LightBlue-500 hidden md:block"} />
                <Button onClick={handleOnClick} className="min-w-[200px]" type="button" variant="primary" label="enad_feed_new_trancriptions" />
            </div>
            <div className="flex flex-col w-full flex-1 overflow-y-auto">
                {data?.sort((a, b) => new Date(b.LastModified) - new Date(a.LastModified))?.map?.((i, index) => (
                    <TrancriptsCard key={index} index={index} item={i} />
                ))}
            </div>
        </div>
    );
}

// export const BubbleMarkDownSubscriber = ({ message }) => {
//     const [_message,setMessgae] = React.useState();
//     useEffect(() => {
//         message.on("data",(...args) => setMessgae(args[0]));
//       }, [message]);
//     return (
//         <Bubble message={{role:"assistant",content:_message}} />
//     );
// }

// export const BubbleMarkDown = ({ message }) => {
//     if(typeof message.content === "string") return (<Bubble message={message} />);
//     return (<BubbleMarkDownSubscriber message={message.content}/>);
// }



export const BubbleMarkDown = ({ message, ...rest }) => {
    return <Bubble {...rest} message={message} >
        <MarkDownViwer markdown={message.content} />
    </Bubble>
}

export const LoadingBubble = () => {
    const { t } = useTranslator();
    return (
        <Bubble message={{ type: 'ai' }}>
            <p className='chat-typing'>
                {t('chat_mensaje_escribiendo')}
                <span>.</span> <span>.</span> <span>.</span>
            </p>
        </Bubble>
    )
}

export const FactoryChat = ({ keyComponent, isFirst, ...message }) => {
    const { createMarkup } = useRemarkable(null);
    const { t } = useTranslator();
    const { user } = useSessionStore();
    const handleonDownloadPDF = ({ title }) => async (currentContent) => {
        await htmlToPdf(t("enad_feed_back_session"), `${user?.first_name || ''} ${user?.last_name || ''}`.trim(), 'Explicar actividad ENAd', createMarkup(currentContent)?.__html, true, { namedoc: title });
    }
    const handleonExportToWord = ({ title }) => async (currentContent) => {
        await exportToDocx(createMarkup(currentContent)?.__html, "Explicar actividad ENAd", t("enad_feed_back_session"), { namedoc: title })
    }
    if (message.content?.includes?.("<stage_1>")) return null;
    if (message.content?.includes?.("<stage_2>")) {
        let stage = message.content;
        stage = stage?.replace?.(/<title>(.*?)<\/title>/gs, '') ?? "";
        stage = clearXML(stage);
        const title = extractOptions(message.content, [/<title>(.*?)<\/title>/gs]);
        return <>
            {isFirst ?
                <GoNextBubble />
                : null}
            <BubbleMarkDown onDownloadPDF={handleonDownloadPDF({ title: title?.[0]?.trim?.() })} onExportToWord={handleonExportToWord({ title: title?.[0]?.trim?.() })} forceDownloadControls message={{ ...message, content: stage }} />
        </>
    }
    if (message.role === "user" && message.content?.includes?.(key_hidden)) return null;
    return <BubbleMarkDown message={message} />;
}

export const GoNextBubble = () => {
    const navigate = useNavigate();
    const { state } = useChat();
    const { lastRequest } = state;
    const { setSuperPowerconection } = useGlobalStore();
    const handleOnClick = () => {
        // se useo el chat parar obtener el di y no se obtuvo de la url del navegador, debido a que mas adelante se pueden necesitar mas variables 
        navigate("/design-enad-class");
        setSuperPowerconection({ target:'enad_class',sessionId: lastRequest?.session_id, idClassProfile: lastRequest?.class_profile_id ?? lastRequest?.class_profile?.id });
    }
    return (
        <Bubble message={{ type: 'ai' }}>
            <Button onClick={handleOnClick} className="min-w-[100px]" type="button" variant="primary" label="enad_feed_back_go_to_planning_next_session" />
        </Bubble>
    )
}

export const GoNextBubbleFeedBack = ({classProfile,sessionId}) => {
    const navigate = useNavigate();
    const { setSuperPowerconection } = useGlobalStore();
    const handleOnClick = () => {
        // se useo el chat parar obtener el di y no se obtuvo de la url del navegador, debido a que mas adelante se pueden necesitar mas variables 
        navigate("/feedback-session-enad");
        setSuperPowerconection({ target:'feedback',idClassProfile: classProfile?.id, sessionId });
    }
    return (
        <Bubble message={{ type: 'ai' }}>
            <Button onClick={handleOnClick} className="min-w-[100px]" type="button" variant="primary" label="enad_feed_back_go_to_new_feedback" />
        </Bubble>
    )
}
